'use client';

import React from 'react';
import localFont from 'next/font/local';
import { Container, SectionLabel } from '../ReferenceChrome';
import AuroraShaders from '@/components/ui/aurora';

const heroDisplay = localFont({
  src: [
    { path: '../../../../public/fonts/fraunces-regular.woff2', weight: '400', style: 'normal' },
    { path: '../../../../public/fonts/fraunces-600.woff2', weight: '600', style: 'normal' },
  ],
});

interface PageHeroRefProps {
  label?: string;
  title: React.ReactNode;
  description?: string;
}

export function PageHeroRef({ label, title, description }: PageHeroRefProps) {
  return (
    <section className="relative w-full pt-14 pb-16 sm:pt-20 sm:pb-24">
      

      <Container className="relative z-10 text-center">
        {label && <SectionLabel>{label}</SectionLabel>}
        
        {/* Headline */}
        <h1
          className={`${heroDisplay.className} mt-6 text-[2.5rem] font-normal leading-[1.15] tracking-tight text-gray-900 sm:text-5xl md:text-[3.5rem]`}
        >
          {title}
        </h1>

        {/* Subheadline */}
        {description && (
          <p className="mx-auto mt-5 max-w-xl text-base font-light leading-relaxed text-gray-500 sm:text-lg">
            {description}
          </p>
        )}
      </Container>

      {/* Bottom border — constrained inside the vertical rails */}
      <div
        className="rail-inset-x absolute bottom-0 left-0 right-0 h-px bg-gray-100"
        aria-hidden
      />
    </section>
  );
}
